import { createStore } from 'vuex'
import auth from './modules/auth'
import filters from './modules/filters'

export default createStore({
  modules: {
    auth,
    filters
  }
})
